import {Typography} from "@mui/material";
import React from "react";
import {imperialWeight} from "./imperialWeight";

const getWeights = (params) => {

    if (params.value > 0) {

        return <div>
            <Typography fontSize={"100%"}
                        variant={"body2"}>{params.value} kg</Typography>
            <Typography fontSize={"100%"}
                        variant={"body2"}>{imperialWeight(params.value)} lbs</Typography>
        </div>;
    }
    else
        return ""
}

export default getWeights;